import { initializeDB } from '../config/db';
import { JOB_SITE_SAFETY_INSPECTION_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const jobSiteSafetyInspectionService = {
    // IndexedDB operations
    async saveToIndexedDB(inspection) {
        try {
            const db = await initializeDB();
            const tx = db.transaction([JOB_SITE_SAFETY_INSPECTION_STORE], 'readwrite');
            const store = tx.objectStore(JOB_SITE_SAFETY_INSPECTION_STORE);
            await store.put(inspection);
            await tx.done;
            console.log('Job Site Safety Inspection saved to IndexedDB:', inspection.uuid);
            return inspection;
        } catch (error) {
            console.error('Error saving to IndexedDB:', error);
            throw error;
        }
    },

    async getFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction([JOB_SITE_SAFETY_INSPECTION_STORE], 'readonly');
            const store = tx.objectStore(JOB_SITE_SAFETY_INSPECTION_STORE);
            const inspection = await store.get(uuid);
            return inspection;
        } catch (error) {
            console.error('Error getting from IndexedDB:', error);
            throw error;
        }
    },

    async getAllFromIndexedDB() {
        try {
            const db = await initializeDB();
            const tx = db.transaction([JOB_SITE_SAFETY_INSPECTION_STORE], 'readonly');
            const store = tx.objectStore(JOB_SITE_SAFETY_INSPECTION_STORE);
            const inspections = await store.getAll();
            return inspections;
        } catch (error) {
            console.error('Error getting all from IndexedDB:', error);
            throw error;
        }
    },

    async deleteFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction([JOB_SITE_SAFETY_INSPECTION_STORE], 'readwrite');
            const store = tx.objectStore(JOB_SITE_SAFETY_INSPECTION_STORE);
            await store.delete(uuid);
            await tx.done;
            console.log('Job Site Safety Inspection deleted from IndexedDB:', uuid);
        } catch (error) {
            console.error('Error deleting from IndexedDB:', error);
            throw error;
        }
    },

    // API operations
    async submit(inspection) {
        try {
            const response = await axiosInstance.post('/job-site-safety-inspection/submit', inspection);
            return response.data;
        } catch (error) {
            console.error('Error submitting inspection:', error);
            throw error;
        }
    },

    async getAll() {
        try {
            const response = await axiosInstance.get('/job-site-safety-inspection');
            return response.data;
        } catch (error) {
            console.error('Error getting inspections:', error);
            throw error;
        }
    },

    async getById(id) {
        try {
            const response = await axiosInstance.get(`/job-site-safety-inspection/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error getting inspection:', error);
            throw error;
        }
    },

    async update(id, inspection) {
        try {
            const response = await axiosInstance.put(`/job-site-safety-inspection/${id}`, inspection);
            return response.data;
        } catch (error) {
            console.error('Error updating inspection:', error);
            throw error;
        }
    },

    async delete(id) {
        try {
            const response = await axiosInstance.delete(`/job-site-safety-inspection/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting inspection:', error);
            throw error;
        }
    },

    async downloadPdf(id) {
        try {
            const response = await axiosInstance.get(`/job-site-safety-inspection/${id}/pdf`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Error downloading PDF:', error);
            throw error;
        }
    }
};

export default jobSiteSafetyInspectionService;

